import Parse from "parse";
import {
  addImageIfExists,
  getClassName,
  setACL,
  setLimit,
  filterKeys,
  convertToPointer
} from "./ParseConfiguration";
import { News } from "../Models/News";
import { handleError } from "./ErrorHandler.ts";


const NEWS_TABLE = getClassName("News")


export async function getNews() {
  try {
    const query = new Parse.Query(NEWS_TABLE)
    query.descending("createdAt")
    query.include("mentionedMembers")
    const count = await query.count()
    setLimit(query, count)
    const result = await query.find()

    return result.map((parseObject) =>
      News.convertFromParseObject(parseObject)
    )
  } catch (error) {
    handleError(error)
    throw error
  }
}

export async function getNewsById(objectId) {
  try {
    const query = new Parse.Query(NEWS_TABLE)
    const parseObject = await query.get(objectId)
    const result = News.convertFromParseObject(parseObject)
    return result

  } catch (error) {
    handleError(error)
    throw error
  }
}

export async function addOrUpdateNews(newNews, heroImage) {
  try {
    const News = NEWS_TABLE
    const news = new News()
    Object.entries(newNews)
      .filter((key) => !filterKeys.includes(key[0]))
      .forEach((key) => {
        news.set(key[0], key[1])
      })
    setACLForNewObject(newNews.objectId, news)
    await addImageIfExists(news, heroImage, "heroImage")
    news.set("mentionedMembers", newNews.mentionedMembers.map((member) => convertToPointer("_User", member.objectId)))
    await news.save()

  } catch (error) {
    handleError(error)
    throw error
  }
}

export function notifyUsersAboutNews(id, title) {
  const params = { newsId: id, newsTitle: title };
  return Parse.Cloud.run("newsNotification", params);
}

export function updateDisplayingValue(news, isNew) {
  const parseObject = new Parse.Query(NEWS_TABLE);
  parseObject.set("objectId", news.objectId);
  parseObject.set("isNew", isNew);

  return parseObject.save();
}

export async function updateNewsHidingValue(objectId, isHiding) {
  try {
    const query = new Parse.Query(NEWS_TABLE)
    query.get(objectId)
    const result = await query.find()
    if (result.length >= 1) {
      result[0].set("hidden", isHiding)
      result[0].save()
    }

  } catch (error) {
    handleError(error)
    throw error
  }
}

export async function deleteNews(objectId) {
  try {
    const query = new Parse.Query(NEWS_TABLE)
    query.get(objectId)
    const result = await query.find()
    if (result.length >= 1) {
      await result[0].destroy()
    }

  } catch (error) {
    handleError(error)
    throw error
  }
}

function setACLForNewObject(parseObject, objectId) {
  if (objectId.length === 0) {
    setACL(parseObject)
  }
}
